import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-funnel-flow',
  templateUrl: './new-funnel-flow.component.html',
  styleUrls: ['./new-funnel-flow.component.scss']
})
export class NewFunnelFlowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
